"use client";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";

export default function TopButton() {
  const topRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    topRef.current.classList.add("fly");
  };
  useEffect(() => {
    function showTopButton() {
      const scrollHeight = window.scrollY;
      setIsVisible(scrollHeight > 50);
    }
    showTopButton();
    window.addEventListener("scroll", showTopButton);
    return () => window.removeEventListener("scroll", showTopButton);
  }, []);
  return (
    <div
      ref={topRef}
      className={`top-button max-md:w-[65px] max-md:bottom-[5.5rem] max-md:right-4 ${
        isVisible ? "opacity-100" : "pointer-events-none opacity-0"
      }`}
      onClick={scrollToTop}
    >
      <Image
        src="/assets/elements/toTop_bird.png"
        width={75}
        height={75}
        alt="到最上面去"
      />
    </div>
  );
}
